'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var productURI = exports.productURI = function productURI(handle) {
  return '/products/' + handle;
};
var queryChar = exports.queryChar = function queryChar(uri) {
  return (/\?/.test(uri) ? '&' : '?'
  );
};
var HTTP_OPTIONS = exports.HTTP_OPTIONS = { credentials: 'include' };

var viewURI = exports.viewURI = function viewURI(type, uri) {
  var VIEW_MAP = {
    simple: 'quickshop-simple',
    modal: 'quickshop'
  };

  if (!VIEW_MAP[type]) {
    return uri;
  }
  return uri + queryChar(uri) + ('view=' + VIEW_MAP[type]);
};

var variantURI = exports.variantURI = function variantURI(variant, uri) {
  if (!variant) {
    return uri;
  }
  return uri + queryChar(uri) + ('variant=' + variant);
};

var getQuickViewURI = exports.getQuickViewURI = function getQuickViewURI(handle, type, variant) {
  return variantURI(variant, viewURI(type, productURI(handle)));
};

var validateQuickview = exports.validateQuickview = function validateQuickview(html) {
  if (!/data-product-main/.test(html)) {
    throw new Error('Invalid Quickview HTML.');
  }
  return html;
};

var fetchPDP = exports.fetchPDP = function fetchPDP(uri) {
  return fetch(uri, HTTP_OPTIONS).then(function (res) {
    if (!res.ok) throw new Error('Failed to fetch quickview.');
    return res;
  }).then(function (res) {
    return res.text();
  }).then(validateQuickview);
};